import React, { useEffect, useState } from "react";
import {
    Button,
    Modal,
    Form,
    Input,
    Table,
    Typography,
    Space,
    Card,
    Upload,
    Popconfirm,
    message,
    Radio
} from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import Papa from "papaparse";
import axios from "axios";
import { useNavigate, useParams } from 'react-router-dom';
import { DataTable } from "../commonfunction/Datatable";
import { getIndianTimestamp } from "../commonfunction/formatDate";
import { MdArrowBack } from "react-icons/md";

const BASEURL = "/api"

const ConsigneeMaster = () => {
    const navigate = useNavigate();
    const { groupId } = useParams()
    // console.log(groupId);
    const [open, setOpen] = useState(false);
    const [bulkUploadOpen, setBulkUploadOpen] = useState(false);
    const [fileList, setFileList] = useState([]);
    // const [consigneeList, setConsignees] = useState([]);

    const [products, setConsignees] = useState([]);
    // console.log(products);
    const [searchTerm, setSearchTerm] = useState("");


    const [currentConsignee, setCurrentConsignee] = useState(null); // Stores Selected Consignee for Editing
    const [editOpen, setEditOpen] = useState(false); // Controls Edit Modal State
    const [value, setValue] = useState({})
    // console.log(value.id);
    const [editForm] = Form.useForm(); // Antd Form Hook
    const [form] = Form.useForm(); // Antd Form Hook
    const userId = value.id

    const handleOpen = () => {
        form.resetFields();
        setOpen(true);
    };

    useEffect(() => {
        const savedInfo = localStorage.getItem("info");
        if (savedInfo) {
            const parsedInfo = JSON.parse(savedInfo);
            setValue(parsedInfo);
        }
        else {
            navigate("/");
        }

    }, []);

    const handleEditOpen = (product) => {
        //console.log(product);

        //// // console.log("Editing Consignee:", product);
        setCurrentConsignee(product);
        editForm.setFieldsValue(product); // Pre-fill form with selected product details
        setEditOpen(true);
    };

    const handleClose = () => setOpen(false);
    // Add Consignee
    const addConsignee = () => {
        form.validateFields().then(async (values) => {
            // // console.log("values", values);
            // // console.log("User ID:", value.id);
            const payload = { ...values, groupId };
            try {
                const response = await axios.post(`${BASEURL}/consigneemaster`, payload);
                // setConsignees([...products, response.data.product]); // Update UI
                fetchConsignees();
                message.success({
                    content: response.data.message,
                    duration: 2, // Time before it disappears (in seconds)
                    style: {
                        marginTop: "25vh", // Moves it to center vertically
                        textAlign: "center", // Ensures text is centered
                        // Moves it to center horizontally
                    }
                });
                handleClose();
            } catch (error) {
                // // console.error("Error adding product:", error);
                alert("Failed to add product!");
            }
        });
    };


    const fetchConsignees = async () => {
        try {
            const response = await axios.get(`${BASEURL}/consignee/${groupId}`);
            // console.log(response);
            const activeProducts = response?.data?.products?.filter(product => product.active === true);

            setConsignees(activeProducts);
        } catch (error) {
            // // console.error("Error fetching products:", error);
        }
    };


    const editConsignee = async () => {
        try {
            const values = await editForm.validateFields(); // Validate form inputs
            const response = await axios.patch(`${BASEURL}/consigneeupdate/${currentConsignee._id}/${value.status}`, values);

            // Update product in the UI
            const updatedConsignees = products.map((p) =>
                p._id === currentConsignee._id ? { ...p, ...values } : p
            );
            setConsignees(updatedConsignees);
            message.success({
                content: response.data.message,
                duration: 2, // Time before it disappears (in seconds)
                style: {
                    marginTop: "25vh", // Moves it to center vertically
                    textAlign: "center", // Ensures text is centered
                    // Moves it to center horizontally
                }
            });
            fetchConsignees();
            // message.success(response.data.message);
            setEditOpen(false); // Close modal after successful edit
        } catch (error) {
            // // console.error("Error updating product:", error);
            message.error("Failed to update product!");
        }
    };


    useEffect(() => {
        fetchConsignees();
    }, []);


    const deleteConsignee = async (id) => {
        //// // console.log("Deleting Consignee:", id);

        try {
            await axios.delete(`${BASEURL}/deleteconsignee/${id}`);
            setConsignees(products.filter((product) => product._id !== id));

            message.success({
                content: "Consignee deleted successfully!",
                duration: 2, // Time before it disappears (in seconds)
                style: {
                    marginTop: "25vh", // Moves it to center vertically
                    textAlign: "center", // Ensures text is centered
                    // Moves it to center horizontally
                }
            });

        } catch (error) {
            // // console.error("Error deleting product:", error);
            message.error("Failed to delete product!");
        }
    };


    const handleUpload = async () => {
        if (fileList.length === 0) {
            message.error("Please select a CSV file to upload.");
            return;
        }

        const file = fileList[0];

        Papa.parse(file.originFileObj, {
            complete: async (result) => {
                let records = result.data.slice(1).map(row => ({
                    name: row[1]?.trim() || "",
                    place: row[2]?.trim() || "",
                    district: row[3]?.trim() || "",
                    mobileNo: isNaN(row[4]?.trim()) ? 0 : parseInt(row[4]?.trim(), 10), // ✅ Handle invalid mobileNo
                    group_id: value?.id, // ✅ Attach the groupId
                }));

                // ✅ Filter valid entries
                records = records.filter(record => record.name && record.place && record.district && record.group_id);

                if (records.length === 0) {
                    message.error("No valid records found in the CSV file.");
                    return;
                }

                try {
                    const response = await axios.post(`${BASEURL}/uploadconsignee`, { products: records });

                    if (response.status === 201) {
                        message.success(response.data.message || "Bulk upload successful!");
                        setConsignees([...products, ...records]);
                        setBulkUploadOpen(false);
                        setFileList([]);
                    } else {
                        message.error("Failed to upload CSV. Please check the file format.");
                    }
                } catch (error) {
                    message.error("Failed to upload CSV. Server error!");
                }
            },
            header: false,
        });
    };

    // Table Columns
    const columns = [
        { field: "id", headerName: "Sr. No.", minWidth: 30, flex: 0.2 },
        { field: "name", headerName: "Name of Consignee", minWidth: 150, flex: 1 },
        { field: "place", headerName: "Place", minWidth: 60, flex: 0.5 },
        { field: "district", headerName: "District", minWidth: 60, flex: 0.5 },
        { field: "mobileNo", headerName: "Mobile No.", minWidth: 40, flex: 0.5 },
        {
            field: "createdAt",
            headerName: "Created Date",
            minWidth: 40,
            flex: 0.5,
        },
        // {
        //     field: "active",
        //     headerName: "Status",
        //     sortable: false,
        //     flex: 0.4,
        //     renderCell: (params) => {
        //         return (
        //             <div
        //                 style={{
        //                     color: params.value === "ACTIVE" ? "green" : "red", // Conditional text color

        //                 }}
        //             >
        //                 {params.value}
        //             </div>
        //         );
        //     },
        // },
        {
            field: "actions",
            headerName: "Actions",
            sortable: false,
            flex: 0.3,
            renderCell: (params) => {

                return (
                    <Space style={{ padding: "7px" }}>
                        {/* ✅ Edit Button */}
                        {/* <EditOutlined size={30} onClick={() => handleEditOpen(params.row._id)}
                        /> */}
                        <Button
                            type="primary"
                            style={{
                                backgroundColor: "#AA2B1D", // Maroon background color
                                borderColor: "#AA2B1D", // Match border color with background
                                color: "white", // White icon color
                            }}
                            icon={<EditOutlined />}
                            onClick={() => handleEditOpen(params.row._id)}
                        />

                    </Space>
                );
            },
        },
    ];



    const findstatus = (status) => {
        return status ? 'ACTIVE' : "INACTIVE"
    }

    const filterconsignees = products.filter((item) =>


        item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.place?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.district?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.mobileNo?.toString().includes(searchTerm.toLowerCase()) ||
        item.createdAt?.toLowerCase().includes(searchTerm.toLowerCase())
    );


    const rows = filterconsignees?.map((item, index) => {
        //console.log(item);

        return {
            id: index + 1,
            name: item.name || "NA",
            place: item.place || "NA",
            district: item.district || "NA",
            mobileNo: item.mobileNo || "NA",
            createdAt: getIndianTimestamp(item.createdAt) || "NA",
            _id: item,
            active: findstatus(item.active) || "NA"
        };
    }) || [];


    return (
        <div >

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", marginTop: "5px" }}>
                <Typography.Title
                    level={3}
                    style={{
                        color: "black",
                        fontSize: "20px",
                        margin: 0,
                        marginLeft: "5px",
                        fontWeight: "400"
                    }}
                >
                    <MdArrowBack />    Consignee Master
                </Typography.Title>
                <div style={{ marginRight: "30px" }}>
                    <Input
                        placeholder="Search Consignee..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{ width: 200, marginRight: "10px" }}
                        allowClear
                    />
                    <Button type="default" icon={<PlusOutlined />} onClick={() => setOpen(true)} style={{ marginRight: "10px" }}>
                        Add Consignee
                    </Button>

                    <Button type="default" icon={<UploadOutlined />} onClick={() => setBulkUploadOpen(true)}>
                        Bulk Upload
                    </Button>
                </div>
            </div>







            <Modal
                title="📤 Bulk Upload Consignees"
                open={bulkUploadOpen}
                onCancel={() => setBulkUploadOpen(false)}
                onOk={handleUpload}
                okText="Upload"
                cancelText="Cancel"
                style={{ top: 30 }}
                centered
            >
                <p>Please upload a CSV file with the following format:</p>
                <p><b>Name, Place, District, Mobile No</b></p>

                <Upload
                    beforeUpload={() => false}
                    onChange={({ fileList }) => setFileList(fileList)}
                    fileList={fileList}
                    accept=".csv"
                >
                    <Button icon={<UploadOutlined />}>Select CSV File</Button>
                </Upload>
            </Modal>

            <Modal
                title="➕ Add a New Consignee"
                open={open}
                onCancel={handleClose}
                onOk={addConsignee}
                okText="Save"
                cancelText="Cancel"
                style={{ top: 30 }}
                centered
            >
                <hr />
                <Form form={form} layout="vertical">
                    <Form.Item
                        label="Name of Consignee"
                        name="name"
                        rules={[{ required: true, message: "Please enter Name of Consignee" }]}
                    >
                        <Input placeholder="Enter Name of Consignee" />
                    </Form.Item>
                    <Form.Item
                        label="Place"
                        name="place"
                        rules={[{ required: true, message: "Please enter place" }]}
                    >
                        <Input placeholder="Enter place " />
                    </Form.Item>

                    <Form.Item
                        label="District"
                        name="district"
                        rules={[{ required: true, message: "Please enter District" }]}
                    >
                        <Input placeholder="Enter District" />
                    </Form.Item>

                    <Form.Item
                        label="Mobile Number"
                        name="mobileNo"
                        rules={[{ message: "Please enter Mobile Number" }]}
                    >
                        <Input placeholder="Enter Mobile Number" />
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                title="✏️ Edit Consignee"
                open={editOpen} // Ensure this is linked to editOpen state
                onCancel={() => setEditOpen(false)} // Close modal when clicking outside
                onOk={editConsignee}
                centered
                style={{ top: 30 }}
            >
                <hr />
                <Form form={editForm} layout="vertical">
                    <Form.Item
                        label="Name of Consignee"
                        name="name"
                        rules={[{ required: true, message: "Please enter Name of Consignee" }]}
                    >
                        <Input placeholder="Enter Name of Consignee" />
                    </Form.Item>
                    <Form.Item
                        label="Place"
                        name="place"
                        rules={[{ required: true, message: "Please enter place" }]}
                    >
                        <Input placeholder="Enter place " />
                    </Form.Item>

                    <Form.Item
                        label="District"
                        name="district"
                        rules={[{ message: "Please enter District" }]}
                    >
                        <Input placeholder="Enter District" />
                    </Form.Item>

                    <Form.Item
                        label="Mobile Number"
                        name="mobileNo"
                        rules={[{ message: "Please enter Mobile Number" }]}
                    >
                        <Input placeholder="Enter Mobile Number" />
                    </Form.Item>
                    <Form.Item
                        name='active'
                        label="Status"
                        rules={[{ required: true, message: 'Please select a status!' }]}
                    >
                        <Radio.Group>
                            <Radio value={true}>Active</Radio>
                            <Radio value={false}>Inactive</Radio>
                        </Radio.Group>
                    </Form.Item>
                </Form>
            </Modal>
            {rows.length > 0 ? (
                <DataTable rows={rows} columns={columns} />
            )
                : (
                    <Card style={{ width: "100%", textAlign: "center", marginTop: "20px" }}>
                        <Typography.Text>No Consignee Details Found</Typography.Text>
                    </Card>
                )
            }
        </div>
    );
};

export default ConsigneeMaster;